// extracted by mini-css-extract-plugin
module.exports = {"tag":"_02712f2b3b--tag--NyUph","tag_close":"_02712f2b3b--tag_close--vIsGX"};